import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { breakpoint, theme } from '../theme';

export const Grid = styled.div`
  padding-left: ${theme.spacings[2].rem};
  padding-right: ${theme.spacings[2].rem};
  ${breakpoint('md')`
    max-width: ${theme.grid.maxWidth};
    margin-left:auto;
    margin-right:auto;  
  `};

  ${breakpoint('lg')`
    max-width: ${theme.grid.maxWidth};
    margin-left:auto;
    margin-right:auto;
    padding-left: ${theme.spacings[5].rem};
    padding-right: ${theme.spacings[5].rem};
  `};
`;

export type RowProps = {
  center?: boolean;
};

export const Row = styled.div<RowProps>`
  display: flex;
  justify-content: ${({ center }) => center && 'center'};
`;

export type StyledColProps = {
  sm: 0 | 1 | 2 | 3 | 4;
  md: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  lg: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
};

const StyledCol = styled.div<StyledColProps>`
  display: ${({ sm }) => (sm === 0 ? 'none' : 'block')};
  width: ${({ sm }) => sm * 25}%;

  ${breakpoint('md')<StyledColProps>`
    display: ${({ md }) => (md === 0 ? 'none' : 'block')};
    width: ${({ md }) => md * 12.5}%;
  `}

  ${breakpoint('lg')<StyledColProps>`
    display: ${({ lg }) => (lg === 0 ? 'none' : 'block')};
    width: ${({ lg }) => lg * 8.33}%;
    max-width: 1280px;
  `}
`;
export type ColProps = Partial<PropsWithChildren<StyledColProps>>;

export const Col: React.FC<ColProps> = (
  { sm = 4, md = 8, lg = 12, children, ...props },
  className
) => (
  <StyledCol sm={sm} md={md} lg={lg} className={className} {...props}>
    {children}
  </StyledCol>
);
